
import { Component, Vue } from "vue-property-decorator";
import NotificationTemplate from "@/components/NotificationTemplate/NotificationTemplate.vue";
import { NOTIFICATION_PROPS_LOCK } from "@/constants/notification";

@Component({
  components: {
    NotificationTemplate,
  },
})
export default class NotificationEmployeeTerminated extends Vue {
  notificationProps = NOTIFICATION_PROPS_LOCK;

  get text() {
    return this.$t("text.employee");
  }
}
